import Spinner from "../../../images/loader.svg";
import Loader from "../../Loader/Loader";
import React from "react";

const TableLoading = () => {
  return <Loader center img={Spinner} />;
};

export default TableLoading;
